<template>
	<tr class="d-flex pl-2">
		<td class="py-1 pl-2 item">{{ name }}</td>
		<td class="py-1 pl-2 value" v-if="column.data_type == 'file'">
			<v-row no-gutters v-for="(file, index) in value.files" :key="'file-' + index" @click="openFile(file.url)">
				<div class="cursor-pointer pa-2" v-if="!file.destroy_flag">
					<v-icon>mdi-file-upload-outline</v-icon>
					{{ file.name }}
				</div>
			</v-row>
		</td>
		<td v-if="fullCheckFLag" class="py-1 check">
			<v-checkbox hide-details="false" v-model="checkbox" @change="changeCheckbox()" label="確認"></v-checkbox>
		</td>
	</tr>
</template>

<script>
import moment from "moment/min/moment.min.js"
export default {
	props: {
		name: {
			type: String,
			required: false,
			default: "",
		},
		value: {
			type: Object,
			required: true,
			default: {},
		},
		fullCheckFLag: {
			type: Boolean,
			required: true,
			default: "",
		},
		column: {
			type: Object,
			required: true,
			default: {},
		},
		wrapFlag: {
			type: Boolean,
			required: true,
			default: false,
		},
	},
	data() {
		return {
			checkbox: false,
			aliveFiles: [],
		}
	},
	watch: {},
	filters: {},
	mounted() {
		this.$emit("childAddMaxCounter")
	},
	methods: {
		changeCheckbox() {
			if (this.checkbox) {
				this.$emit("childChecked")
			} else {
				this.$emit("childNotChecked")
			}
		},
		openFile(url) {
			window.open(url, "_blank")
		},
	},
}
</script>

<style lang="scss" scoped>
th,
td {
	border-left: solid gray 1px;
	&:first-child {
		border-left: none;
	}
}
tr {
	border-bottom: solid gray 1px;
}
td.item {
	width: 20%;
}
td.value {
	width: 60%;
}
td.check {
	width: 20%;
}
td td {
	white-space: pre-wrap;
}

.matter-record {
	td {
		line-height: 1.2;
		padding: 0.25rem 1rem;
		.matter-product-record {
			&:not(:first-child) {
				border-top: 1px solid whitesmoke;
			}
			td {
				padding: 0.25rem 0;
				border: none;
			}
		}
	}
}

.point-cell {
	margin-bottom: 0;
	word-break: break-all;
	white-space: pre-wrap;
}
.v-messages.theme--light {
	display: none;
}
.v-input--selection-controls {
	margin-top: 0 !important;
}
.pre-wrap {
	white-space: pre-wrap;
}
.cursor-pointer {
	cursor: pointer;
}
</style>
